











































import { Component, Mixins } from "vue-property-decorator";
import UserMixin from "@/mixins/userMixin";
import Cookies from "js-cookie";
import AxiosMixin from "@/mixins/axiosMixin";
import FireStoreMixin from "#/mixins/firestoreMixin";
import { COLLECTION_ASSIGN_MEMBER_UPDATE } from "@/consts/envFireStore";

@Component
export default class AppMenu extends Mixins(
  UserMixin,
  AxiosMixin,
  FireStoreMixin
) {
  /** スナップショットのリスナー */
  private unsubscribeAssignListener: (() => void) | null = null;

  /** アサイン可能かどうか */
  private is_assignable = false;

  /** アサイン状態 */
  private assignUser: { id: number; status: number } = { id: 0, status: 0 };

  /** 受付可能状態かどうか */
  private get AttendanceStatus(): boolean {
    return this.assignUser.id !== 0 && this.assignUser.status === 1;
  }

  created() {
    this.postJsonNoloading(
      window.base_url + "/api/admin/assign_admin_user/get",
      {},
      (res) => {
        // 自分のアサイン情報取得
        this.assignUser = res.data.assign_admin_user;
        this.is_assignable = res.data.is_assignable;
        if (this.is_assignable) {
          // アサイン
          this.unsubscribeAssignListener = this.getFirestoreDB()
            .collection(COLLECTION_ASSIGN_MEMBER_UPDATE)
            .doc("1")
            .onSnapshot(() => {
              this.postJsonNoloading(
                window.base_url + "/api/admin/assign_admin_user/get",
                {},
                (res) => {
                  // 自分のアサイン情報取得
                  this.assignUser = res.data.assign_admin_user;
                  this.is_assignable = res.data.is_assignable;
                }
              );
            });
        }
      }
    );
  }

  beforeDestroy() {
    // スナップショットのリスナー解除
    if (this.unsubscribeAssignListener) {
      this.unsubscribeAssignListener();
      this.unsubscribeAssignListener = null;
    }
  }

  //ログアウト
  private async logout() {
    if (!(await this.$openConfirm("ログアウトしますか？"))) {
      return;
    }
    window.token = "";
    Cookies.set("admin-token", "");
    window.reftoken = "";
    Cookies.set("admin-reftoken", "");
    location.href = "/";
  }
}
